import { render, staticRenderFns } from "./ListEmpresas.vue?vue&type=template&id=6561116e"
import script from "./ListEmpresas.vue?vue&type=script&lang=js"
export * from "./ListEmpresas.vue?vue&type=script&lang=js"
import style0 from "./ListEmpresas.vue?vue&type=style&index=0&id=6561116e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports